import { useTranslation } from "react-i18next";

interface FeedbackRequestMessageQuoteProps {
  message: string;
  ariaLabelKey?: string;
  className?: string;
}

function FeedbackRequestMessageQuote({
  message,
  ariaLabelKey = "Feedback.CollabDoc.RequestMessageAria",
  className = "mb-3 rounded-r-md border-l-2 border-l-gray-300 bg-gray-50/90 px-3 py-2.5 text-sm text-gray-600 whitespace-pre-wrap break-words",
}: FeedbackRequestMessageQuoteProps) {
  const { t } = useTranslation();
  const trimmed = message.trim();

  if (!trimmed) {
    return null;
  }

  return (
    <blockquote
      className={className}
      aria-label={t(ariaLabelKey, {
        defaultValue: "Message from the person who requested feedback",
      })}
    >
      {trimmed}
    </blockquote>
  );
}

export default FeedbackRequestMessageQuote;
